/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTiposDivisiones from 'Infotrack@Modelos/smartStock/tiposDivisiones';
import IFiltrosTiposDivisiones from 'Infotrack@Modelos/smartStock/tiposDivisiones/entidades/filtrosTiposDivisiones';
import ITiposDivisiones from 'Infotrack@Modelos/smartStock/tiposDivisiones/entidades/tiposDivisiones';

export default class ControladorModeloTiposDivisiones {
    private modeloTiposDivisiones: ModeloTiposDivisiones;
    constructor() {
        this.modeloTiposDivisiones = new ModeloTiposDivisiones();
    }

    public consultarTiposDivisiones() {
        return this.modeloTiposDivisiones.consultarTiposDivisiones().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTiposDivisiones(tiposDivisiones: ITiposDivisiones) {
        await this.modeloTiposDivisiones.crearTiposDivisiones(tiposDivisiones);
    }

    public async editarTiposDivisiones(tiposDivisiones: ITiposDivisiones) {
        await this.modeloTiposDivisiones.editarTiposDivisiones(tiposDivisiones);
    }
    public async eliminarTiposDivisiones(tiposDivisiones: ITiposDivisiones) {
        await this.modeloTiposDivisiones.eliminarTiposDivisiones(tiposDivisiones);
    }

    public validarEntidad(tiposDivisiones: ITiposDivisiones): boolean {
        if (tiposDivisiones.TipoDivisionDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarPorFiltroTiposDivisiones(tiposDivisiones: Partial<IFiltrosTiposDivisiones>) {
        return await (await this.modeloTiposDivisiones.consultarListaTiposDivisionesPorFiltro(tiposDivisiones)).data
            .Entidades;
    }
}
